import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Environment, Feature } from '@enums';

var FeaturesServiceClass = /*#__PURE__*/function () {
  function FeaturesServiceClass() {
    var _defineProperty2;

    _classCallCheck(this, FeaturesServiceClass);

    _defineProperty(this, "configs", (_defineProperty2 = {}, _defineProperty(_defineProperty2, Feature.ServiceWorker, _defineProperty({}, Environment.Dev, true)), _defineProperty(_defineProperty2, Feature.MockAPI, _defineProperty({}, Environment.Dev, false)), _defineProperty(_defineProperty2, Feature.Socket, _defineProperty({}, Environment.Dev, false)), _defineProperty2));
  }

  _createClass(FeaturesServiceClass, [{
    key: "available",
    value: function available(featureName) {
      return FeaturesServiceClass.isFeatureAvailable(this.configs[featureName]);
    }
  }], [{
    key: "isFeatureAvailable",
    value: function isFeatureAvailable(config) {
      switch (process.env.server) {
        case 'dev':
          {
            return config.dev;
          }

        default:
          {
            return false;
          }
      }
    }
  }]);

  return FeaturesServiceClass;
}();

var FeaturesService = new FeaturesServiceClass();
export { FeaturesService };